import gql from 'graphql-tag';

import { Mediator } from '@spotahome/soyuz-mediator';

import { TOKEN_EXPIRED } from '../../channels';

const QUERY_ALERTS = gql`
  query Alerts {
    userInfo {
      email
      fullname
    }
    cities {
      id
      currencyIsoCode
    }
    isLogged
    alerts {
      id
      cityId
      moveIn
      moveOut
      minPrice
      maxPrice
      propertyTypes
      outOfDate
      cityAreaIds
      lastAlertNotification {
        id
        status
        transitionedAt {
          date
          timezone_type
          timezone
        }
        alertListings {
          rentableUnitId
          title
          price {
            amount
            code
          }
          url
          isPriceFrom
          mainPhotoUrl
          firstAvailableDate
        }
      }
    }
  }
`;

const triggerTokenError = err => {
  if (err.message === 'GraphQL error: Token expired') {
    Mediator.publish(TOKEN_EXPIRED);
  }
};

export const getAlerts = client => () =>
  client
    .query({
      query: QUERY_ALERTS,
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    })
    .catch(triggerTokenError);

export default {
  getAlerts
};
